
import {
    PropType,
    defineComponent,
    ref,
    watch,
} from 'vue';
import EntityTab, { ChangeLog, UseEntityDetailTabs } from './entity-route-util';
import FabBannerBtn from '@redviking/argonaut-core-ui/src/components/FabBannerBtn';
import ChangesDialog from './ChangesDialog.vue';

export type EntityDetailStyling = {
    width?: string,
    margin?: {
        top?: number,
        left?: number,
        right?: number,
        bottom?: number,
    },
}

const entityDetailPropsConfig = {
    useEntityPadding: { type: Boolean, required: true }, // This prop controls the pb-4 that gets applied to the entire entity
    warnUnsaved: { type: Boolean, required: false, default: false }, // This prop is passed in from `RouteEntityDetail` but is never used??
    busy: { type: Boolean, required: false, default: false },
    activeTabIdx: { type: Number, required: false, default: 0 },
    /**
     * Whether the save button is shown in the banner. Disable this if saving UI is managed by child components
     */
    allowSaveFab: { type: Boolean, required: false, default: false },
    allowCancelFab: { type: Boolean, required: false, default: false },
    showBackBtn: { type: Boolean, required: false, default: false },
    /**
     * Whether to show the edit button in the banner when not editing
     */
    canEdit: { type: Boolean, required: false, default: false },
    /**
     * Whether to show the fork button in the banner when editing
     */
    canFork: { type: Boolean, required: false, default: false },
    editing: { type: Boolean, required: false, default: false },
    forking: { type: Boolean, required: false, default: false },
    useEntityDetailTabs: { type: [ Function, Boolean ] as PropType<UseEntityDetailTabs>, required: false, default: true },
    tabs: {
        type: [ Array, Function ] as PropType<EntityTab[] | (() => EntityTab[])>, required: true, default: () => [],
    },
    hasChanges: { type: Boolean, required: false, default: false },
    entityChangesDetail: {
        default: null,
        required: false,
        type: Object as PropType<ChangeLog.EntityChangesDetail>,
    },
    entityStyling: {
        default: null,
        required: false,
        type: Object as PropType<EntityDetailStyling>,
    },
};

export default defineComponent({
    name: 'EntityDetail',
    components: {
        FabBannerBtn,
        ChangesDialog,
    },
    props: entityDetailPropsConfig,
    emit: [ 'back', 'update:activeTabIdx', 'update:editing' ],
    setup (props) {

        const transitionName = ref('');

        watch(() => props.activeTabIdx, (toIndex, fromIndex) => {
            if (toIndex < fromIndex) {
                transitionName.value = 'enter-left';
            } else if (toIndex > fromIndex) {
                transitionName.value = 'enter-right';
            } else {
                transitionName.value = '';
            }
        });

        return {
            transitionName,
            changesDialogOpen: ref(false),
        };
    },
});

